const initialState = {
	selectedDisease: null,
	prevalenceCountry: {
		country: null,
	},
};

export const prevalence = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_SELECTED_DISEASE':
			return {
				...state,
				selectedDisease: action.disease,
			};
		case 'SET_PREVALENCE_SELECTED_COUNTRY':
			return {
				...state,
				prevalenceCountry: {
					country: action.country,
					lat: action.lat,
					lng: action.lng,
				},
			};
		default:
			return state;
	}
};
